import { TableProps } from './Types'

const Table = ({ children, style = {}, width }: TableProps) => {
  return <div style={{ ...style, width }}>{children}</div>
}

export { Table }
